#@import Booking.Models.Attribute
#@import Booking.Collections.Base
#@export Booking.Collections.Attributes

class Booking.Collections.Attributes extends Booking.Collections.Base
  model: Booking.Models.Attribute

  getPhone: ->
    @find (attribute) -> attribute.isPhone()

  getTextNotifications: ->
    @find (attribute) -> attribute.isTextNotifications()

  getPartySize: ->
    @find (attribute) -> attribute.isPartySize()

  getQuestions: ->
    @filter (attribute) -> attribute.isQuestion()

  getAdditionalFields: ->
    @filter (attribute) -> attribute.isPhone() or attribute.isQuestion()
